import React from 'react'
import injectSheet from 'react-jss'
import styles from './support.styles'
import Button from 'pobble-components/dist/button'
import cover from './training-cover-video.jpg'
import meeting from './moderation-meeting.png'
import usingmoderation from './hero-image-2.png'
import beyond from './beyond-gut-feeling-sml.png'
import laptop from './mod-lp.png'
import floatingteacher from './floating_teacher.png'
import { useMe } from 'pobble-components/dist/pobble-user'
import { useSubscriptionPolicy } from 'pobble-components/dist/subscriptions'

const Support = ({ classes }) => {
  const examplificationSp = useSubscriptionPolicy(
    sp => sp.moderation.examplification_material
  )

  return (
    <div className={classes.container}>
      <div className={classes.intro}>
        <h2>Training and support</h2>
        <p>
          Improve the accuracy of your writing assessments with quality training
          and access to our online moderation tool
        </p>
      </div>
      <div className={classes.boxes}>
        <div className={classes.box}>
          <a
            href="https://share.hsforms.com/1cONdv1_gQtaU80wficw2Rw4oqv9"
            target="_blank"
            rel="noopener noreferrer">
            <img src={usingmoderation} alt="Using Moderation" />
          </a>
          <h3>KS2 Statutory moderation</h3>
          <p>
            Academies, free schools and independent schools in England have
            until January 9th to choose their statutory moderation provider. Did
            you know you can now select Pobble as your statutory assessment
            provider, regardless of location? Schools describe our statutory
            moderation sessions as a real celebration of writing and teachers’
            expertise.
          </p>
          <Button
            href="https://share.hsforms.com/1cONdv1_gQtaU80wficw2Rw4oqv9"
            _blank="_blank"
            rel="noopener noreferrer"
            tall>
            Get in touch
          </Button>
        </div>

        <div className={classes.box}>
          <a
            href="https://drive.google.com/file/d/1jH64u2fTgVyOqW-QKLQFqQnflLKuJr_s/view"
            target="_blank"
            rel="noopener noreferrer">
            <img src={meeting} alt="Moderation Meeting" />
          </a>
          <h3>Assessment courses</h3>
          <p>
            Explore our range of online training sessions for Year 6 teachers
            and assessment leads to enhance your skills and provide invaluable
            opportunities to collaborate with fellow teachers and leaders.
            Academies and Independent Schools who have a statutory assessment
            contract with us have unlimited access to all these course, at no
            extra charge.
          </p>
          <Button
            href="https://drive.google.com/file/d/1jH64u2fTgVyOqW-QKLQFqQnflLKuJr_s/view"
            _blank="_blank"
            rel="noopener noreferrer"
            tall>
            Find out more
          </Button>
        </div>

        <div className={classes.box}>
          <a
            href="https://www.eventbrite.com/cc/pobble-assessment-moderation-2596279"
            target="_blank"
            rel="noopener noreferrer">
            <img src={laptop} alt="Moderation Meeting" />
          </a>
          <h3>Free training</h3>
          <p>
            English and Assessment Leads, book your free place on our training
            course{' '}
            <strong>
              Using Pobble to deliver effective moderation sessions
            </strong>
            . In these interactive, small group sessions, you'll learn how to
            plan and facilitate moderation sessions that are positive, valuable
            and improve the consistency and accuracy of writing assessment
            judgements.
          </p>
          <Button
            href="https://www.eventbrite.com/cc/pobble-assessment-moderation-2596279"
            _blank="_blank"
            rel="noopener noreferrer"
            tall>
            Sign up
          </Button>
        </div>

        <div className={classes.box}>
          <a
            href="https://help.pobble.com/knowledge/moderation-faqs"
            target="_blank"
            rel="noopener noreferrer">
            <img src={beyond} alt="Beyond Moderation" />
          </a>
          <h3>Read our FAQs</h3>
          <p>
            Have a question about Pobble online moderation? Visit our helpdesk
            to find a selection of support videos and all the answers to
            commonly asked questions about our tools and training.
          </p>
          <Button
            href="https://help.pobble.com/knowledge/moderation-faqs"
            _blank="_blank"
            rel="noopener noreferrer"
            tall>
            Read the FAQs
          </Button>
        </div>
      </div>
    </div>
  )
}

export default injectSheet(styles)(Support)
